import { ActionTypes } from 'redux/utils/Value'

export default ActionTypes('OLDEST_INCIDENT_REPORT_DATE')